import { render, staticRenderFns } from "./alocacao-estrategica-chart-body.vue?vue&type=template&id=003a430e&"
import script from "./alocacao-estrategica-chart-body.vue?vue&type=script&lang=js&"
export * from "./alocacao-estrategica-chart-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('003a430e')) {
      api.createRecord('003a430e', component.options)
    } else {
      api.reload('003a430e', component.options)
    }
    module.hot.accept("./alocacao-estrategica-chart-body.vue?vue&type=template&id=003a430e&", function () {
      api.rerender('003a430e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/alocacao-estrategica/alocacao-estrategica-chart-body.vue"
export default component.exports